import PropTypes from 'prop-types';
// @mui
import { Typography, Stack } from '@mui/material';
//
import Image from '../image';

// ----------------------------------------------------------------------

EmptyContent.propTypes = {
  sx: PropTypes.object,
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
};

export default function EmptyContent({
  title,
  description,
  img = '/assets/illustrations/illustration_empty_content.svg',
  imgAlt = 'Conteúdo vazio',
  action = null,
  sx,
  ...other
}) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: 1,
        textAlign: 'center',
        p: { xs: 3, sm: 5, md: 8 },
        ...sx,
      }}
      {...other}
    >
      <Image
        disabledEffect
        alt={imgAlt}
        src={img}
        sx={{ width: 1, maxWidth: { xs: 180, sm: 220, md: 240 }, height: 'auto', mb: 3 }}
      />

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}

      {action && (
        <Stack
          sx={{
            mt: 3,
            width: { xs: 1, sm: 'auto' },
            '& .MuiButton-root': { width: { xs: 1, sm: 'auto' } },
          }}
        >
          {action}
        </Stack>
      )}
    </Stack>
  );
}
